export default "__VITE_ASSET__Bx55Lrsj__"